import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import { useMixpanel } from '../../../shared/hooks/useMixpanel';
import PropTypes from 'prop-types';
import { mixpanelLoginEvent, signInWithText } from '../textConsts';
import useMediaQuery from '../../../shared/hooks/useMediaQuery';
import { isMobileQuery } from '../../../shared/MediaQuery/mediaQueryUtils';

export const BeeheroGoogleSignIn = ({ onSignIn }) => {
    const { trackEvent } = useMixpanel();
    const isMobile = useMediaQuery(isMobileQuery);

    const onSuccess = (result) => {
        const { credential: token } = result;
        const credentialsData = jwt_decode(token);

        trackEvent(mixpanelLoginEvent.GOOGLE_SIGN_IN, {
            [mixpanelLoginEvent.USER_EMAIL]: credentialsData.email,
            [mixpanelLoginEvent.SIGN_IN_METHOD]: mixpanelLoginEvent.GOOGLE,
            [mixpanelLoginEvent.SIGN_IN_TYPE]: mixpanelLoginEvent.SUCCESS
        });

        const payload = {
            email: credentialsData.email,
            googleAuthToken: token
        };
        onSignIn && onSignIn(payload);
    };
    const onFailure = (result) => {
        try {
            const { credential: token } = result;

            const credentialsData = jwt_decode(token);
            trackEvent(mixpanelLoginEvent.GOOGLE_SIGN_IN, {
                [mixpanelLoginEvent.USER_EMAIL]: credentialsData.email,
                [mixpanelLoginEvent.SIGN_IN_METHOD]: mixpanelLoginEvent.GOOGLE,
                [mixpanelLoginEvent.SIGN_IN_TYPE]: mixpanelLoginEvent.FAILURE
            });
        } catch (err) {}
    };

    return (
        <GoogleLogin
            shape="circle"
            onSuccess={onSuccess}
            onFailure={onFailure}
            logo_alignment="center"
            useOneTap={false}
            text={signInWithText}
            context="signin"
            width={isMobile ? null : 360}
        />
    );
};

BeeheroGoogleSignIn.propTypes = {
    onSignIn: PropTypes.func
};
